// PLAT-TOS-LAYERED-1 — product names used by the terms addendum screens.
// Mirrors PRODUCT_META labels in apps/api/entitlements.py. Needed client-side
// because /terms/:product is a public page (no /v1/me to read labels from).
import type { ProductKey } from '@/lib/productNav'

export const PRODUCT_TERMS_LABELS: Record<ProductKey, string> = {
  qoe: 'Quality of Earnings',
  otcid: 'OTCID Disclosure',
  valuation: 'Business Valuation',
  attest: 'Verification Letters',
}

export function isTermsProduct(value: string | undefined): value is ProductKey {
  return !!value && Object.prototype.hasOwnProperty.call(PRODUCT_TERMS_LABELS, value)
}
